export const SET_GROUPS_LOADED = "SET_GROUPS_LOADED";

export const setGroupsLoaded = (groupsLoaded: boolean) => {
  return {
    groupsLoaded,
    type: SET_GROUPS_LOADED
  };
};
